<template>
  <div class="text-center my-6 mx-8">
      <v-img
      src="@/assets/banner.png" max-height="150" contain></v-img>
      <h1 class="light-green--text">Welcome to Reco demo app!</h1>
      <p>
        This app demo works best if you scroll to the bottom and hide the navigation bar of your browser.
        This way you're able to experience the app as if it were a native application.
        Alternatively, you can click the button on the down-right corner to hide it automatically!
      </p>
  </div>
</template>

<script>
export default {
    name:'Home',

}
</script>

<style>

</style>